import React, { useEffect, useState } from 'react';
import { Button, Dialog, Box, makeStyles, DialogTitle, DialogContent } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { CustomToast } from '@jumbo/components/custom/Toast';

const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
}));

const SessionModal = props => {
  const { openDialog = false, close, submit } = props;
  const classes = addStyle();

  const [loading, setLoading] = useState(false);
  const [secsToLogout, setSecsToLogout] = useState(10);

  useEffect(() => {
    if (openDialog) {
      const interval = setInterval(() => {
        setSecsToLogout(seconds => seconds - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [openDialog]);

  useEffect(() => {
    if (secsToLogout === 0) {
      onCloseDialog();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secsToLogout]);

  const onCloseDialog = event => {
    if (loading) {
      event.preventDefault();
      return;
    }
    setLoading(false);
    close();
  };

  const onSubmitClick = () => {
    setLoading(true);
    submit();
    setLoading(false);
    setSecsToLogout(10);
  };

  return (
    <Dialog open={openDialog} onClose={onCloseDialog}>
      <CustomToast />
      <DialogTitle className={classes.dialogTitleRoot}>
        {' '}
        Sesión expirada cerrando sesión en {secsToLogout >= 0 ? secsToLogout : 0}
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
          <p>Su sesión ha expirado, ¿Desea mantenerse conectado?</p>
        </Box>
        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button onClick={onCloseDialog} disabled={loading}>
            NO
          </Button>
          <Box ml={2}>
            <Button variant="outlined" color="primary" onClick={onSubmitClick} disabled={loading}>
              {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'SI'}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SessionModal;
